<template>
    <b-container>
        <b-card no-body>
            <b-card-header header-tag="nav">
                <b-nav class="card-header-tabs" card-header tabs>
                    <b-nav-item to="/cms/shop/dmix" exact exact-active-class="active">DMIX Cloud</b-nav-item>
                </b-nav>
            </b-card-header>
            <b-card-body>
                <router-view></router-view>
            </b-card-body>
        </b-card>
    </b-container>
</template>
<script>
    export default {
        name: 'shop-management',
    }
</script>

<style>
</style>